var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconExpand(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.5 11.5C0.8125 11.5 0.25 12.0625 0.25 12.75V16.5C0.25 17.1875 0.8125 17.75 1.5 17.75H5.25C5.9375 17.75 6.5 17.1875 6.5 16.5C6.5 15.8125 5.9375 15.25 5.25 15.25H2.75V12.75C2.75 12.0625 2.1875 11.5 1.5 11.5ZM1.5 6.5C2.1875 6.5 2.75 5.9375 2.75 5.25V2.75H5.25C5.9375 2.75 6.5 2.1875 6.5 1.5C6.5 0.8125 5.9375 0.25 5.25 0.25H1.5C0.8125 0.25 0.25 0.8125 0.25 1.5V5.25C0.25 5.9375 0.8125 6.5 1.5 6.5ZM15.25 15.25H12.75C12.0625 15.25 11.5 15.8125 11.5 16.5C11.5 17.1875 12.0625 17.75 12.75 17.75H16.5C17.1875 17.75 17.75 17.1875 17.75 16.5V12.75C17.75 12.0625 17.1875 11.5 16.5 11.5C15.8125 11.5 15.25 12.0625 15.25 12.75V15.25ZM11.5 1.5C11.5 2.1875 12.0625 2.75 12.75 2.75H15.25V5.25C15.25 5.9375 15.8125 6.5 16.5 6.5C17.1875 6.5 17.75 5.9375 17.75 5.25V1.5C17.75 0.8125 17.1875 0.25 16.5 0.25H12.75C12.0625 0.25 11.5 0.8125 11.5 1.5Z",
    fill: "#007AFF"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconExpand);
export default __webpack_public_path__ + "static/media/icon_expand.da65ea07ad0efc9201ae92f9a21cd177.svg";
export { ForwardRef as ReactComponent };